import { Play } from "lucide-react";

export const SectionHeader = ({ eyebrow, title, kicker, testId }) => {
  return (
    <div
      data-testid={testId || "section-header"}
      className="mb-12 md:mb-16 flex flex-col gap-3"
    >
      {eyebrow && (
        <div className="flex items-center gap-3">
          <span className="h-px w-10 bg-[#FF3B30]" />
          <span className="text-xs uppercase tracking-[0.3em] font-bold text-[#FF3B30]">
            {eyebrow}
          </span>
        </div>
      )}
      <h2 className="font-display text-4xl sm:text-5xl md:text-6xl uppercase tracking-tight leading-none text-white">
        {title}
      </h2>
      {kicker && (
        <p className="text-base md:text-lg text-zinc-400 max-w-2xl">
          {kicker}
        </p>
      )}
    </div>
  );
};

export const PlayBadge = ({ duration }) => (
  <>
    <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent" />
    <div className="absolute inset-0 flex items-center justify-center opacity-90 group-hover:opacity-100 transition-opacity">
      <div className="h-14 w-14 rounded-full bg-[#FF3B30] flex items-center justify-center">
        <Play className="h-6 w-6 text-white fill-white ml-0.5" />
      </div>
    </div>
    {duration && (
      <div className="absolute top-3 right-3 bg-black/70 backdrop-blur px-2 py-0.5 text-xs font-bold text-white tracking-wider">
        {duration}
      </div>
    )}
  </>
);
